import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const HomeGallery = () => {
  const [GalleryUser, setGalleryUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getgallery");
      setGalleryUser(response.data);
    };
    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      await axios.delete(`https://admin.gosaviadvanceddentalclinic.com/api/deletegallery/${userId}`);
      setGalleryUser((prevUser) =>
        prevUser.filter((user) => user.id !== userId)
      );
      toast.error("Data Deleted Successfully!");
      navigate("/Gallery");
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-2"></div>
        <div className="col-lg-10 slider-home">
          <div>
            <h3 className="slider-heading">Gallery Image</h3>
            <Link to="/Gallery-add">
              <button className="add-button">
                <i class="fa-solid fa-plus"></i> Add Gallery
              </button>
            </Link>
          </div>
          <div className="row image-details">
            {GalleryUser.map((user) => {
              return (
                <div className="col-lg-4 slider-image">
                  <img src={user.galleryimage} alt="Gallery" />
                  <div className="icons">
                    <ul>
                      <li>
                        <Link to={`/Gallery-view/` + user.id}>
                          <i className="fa-regular fa-eye" title="View"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to={`/Gallery-edit/` + user.id}>
                          <i
                            className="fa-regular fa-pen-to-square"
                            title="Edit"
                          ></i>
                        </Link>
                      </li>
                      <li>
                        <span onClick={() => deleteUser(user.id)}>
                          <i class="fa-solid fa-trash-can" title="Delete"></i>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export const GalleryAdd = () => {
  const [GalleryImage, setGalleryImage] = useState({
    galleryimage: ""
  });
  const navigate = useNavigate();
    const [previewImage, setPreviewImage] = useState("");

   const imageHandler = (e) => {
     const file = e.target.files[0];
 
     if (file) {
       const allowedTypes = ["image/jpg", "image/jpeg", "image/png", "image/webp"];
       const maxSize = 2 * 1024 * 1024; // 2MB
 
       // Validate type
       if (!allowedTypes.includes(file.type)) {
         toast.error("Only JPG, JPEG, PNG and WEBP files are allowed.");
         return;
       }
 
       // Validate size
       if (file.size > maxSize) {
         toast.error("Image size should be under 2MB.");
         return;
       }
 
       // Optional: Dimension check
       const img = new Image();
       const objectUrl = URL.createObjectURL(file);
       img.src = objectUrl;
       img.onload = () => {
         if (img.width > 1050 || img.height > 850) {
           toast.error("Image dimensions should not exceed 1050x850.");
           URL.revokeObjectURL(objectUrl);
           return;
         }
 
         setGalleryImage((prev) => ({ ...prev, galleryimage: file }));
         setPreviewImage(objectUrl); // Show preview
       };
     }
   };

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("galleryimage", GalleryImage.galleryimage);

    try {
      const response = await axios.post(
        "https://admin.gosaviadvanceddentalclinic.com/api/creategallery",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Image uploaded successfully!");
      navigate("/Gallery");
    } catch (error) {
      toast.error("Error uploading image!");
      console.error("Upload error:", error);
    }
  };

  return (
    <div className="container-fluid popup-container">
      <div className="popup-content">
        <div className="adduser">
          <Link to="/Gallery">
            <i className="fa-solid fa-xmark"></i>
          </Link>
          <h4>Add Gallery Image</h4>
          <hr />
          <form className="row" onSubmit={submitForm}>
            <div className="col-lg-6 col-md-6 col-sm-12 popup-inputform">
            <input
                  type="file"
                  id="galleryimage"
                  name="galleryimage"
                  accept="image/*"
                  onChange={imageHandler}
                />
                {previewImage && (
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "250px",
                      borderRadius: "8px",
                      display: "block",
                      margin: "10px auto"
                    }}
                  />
                )}
            </div>
            <div className="submitform">
              <button type="submit">Add</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export const HomeGalleryEdit = () => {
  const [GalleryImage, setGalleryImage] = useState({
    galleryimage: "",
  });
   const [previewImage, setPreviewImage] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

    // Set preview image if already available
    useEffect(() => {
      if (
        GalleryImage.galleryimage &&
        typeof GalleryImage.galleryimage === "string"
      ) {
        setPreviewImage(GalleryImage.galleryimage);
      }
    }, [GalleryImage.galleryimage]);

      // Handle image change
  const handleImageChange = (e) => {
    const file = e.target.files[0];
  
    if (file) {
      const allowedTypes = ["image/jpg", "image/jpeg", "image/png", "image/webp"];
      const maxSize = 2 * 1024 * 1024; // 2MB
  
      // ✅ Type check
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG, JPEG, PNG and WEBP files are allowed.");
        return;
      }
  
      // ✅ Size check
      if (file.size > maxSize) {
        toast.error("Image size should be under 2MB.");
        return;
      }
  
      // ✅ Optional: Dimension check (example: max 1920x1080)
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
  
      img.onload = () => {
        const { width, height } = img;
  
        // Example check (adjust if needed)
        if (width > 1050 || height > 850) {
          toast.error("Image dimensions should not exceed 1050x850.");
          URL.revokeObjectURL(objectUrl); // Clean up
          return;
        }
  
        setSelectedImage(file);
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result);
        };
        reader.readAsDataURL(file);
      };
    }
  };
  
  useEffect(() => {
    const editData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getonegallery/${id}`
        );
        setGalleryImage(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    editData();
  }, [id]);


  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    if (selectedImage) {
      formData.append("galleryimage", selectedImage);
    }

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updategallery/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.info("Data Updated Successfully!");
      navigate("/Gallery");
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div className="container-fluid edit-popup-container">
      <div className="edit-popup-content">
        <div className="edit-adduser">
          <Link to="/Gallery">
            <i className="fa-solid fa-xmark"></i>
          </Link>
          <h4>Update Gallery Image</h4>
          <hr />
          <form className="row" onSubmit={submitForm}>
            <div className="col-lg-6 col-md-6 col-sm-12 edit-popup-inputform">
            <input
                  type="file"
                  className="form-control"
                  name="galleryimage"
                  onChange={handleImageChange}
                  accept="image/*"
                />
                <br />
                {previewImage && (
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "250px",
                    }}
                  />
                )}
            </div>
            <div className="edit-submitform">
              <button type="submit">Update</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export const HomeGalleryView = () => {
  const [GalleryUser, setGalleryUser] = useState({
    galleryimage: "",
  });
  const { id } = useParams();

  useEffect(() => {
    const GalleryData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getonegallery/${id}`
        );
        setGalleryUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    GalleryData();
  }, [id]);

  return (
    <div className="view-image">
       <Link to="/Gallery" className="back-btn">
                <i className="fa-solid fa-arrow-left"></i> Back
              </Link>
      <img src={GalleryUser.galleryimage} alt="Gallery" />
    </div>
  );
};
